import '../ui-anchor/ui-anchor.en.js';
import '../ui-annotation/ui-annotation.en.js';
import '../ui-assets/ui-assets.en.js';
import '../ui-autocomplete/ui-autocomplete.en.js';
import '../ui-breadcrumbs/ui-breadcrumbs.en.js';
import '../ui-calendar/ui-calendar.en.js';
import '../ui-chip/ui-chip.en.js';
import '../ui-comparison-cards/ui-comparison-cards.en.js';
import '../ui-cookie-consent/ui-cookie-consent.en.js';
import '../ui-countdown/ui-countdown.en.js';
import '../ui-curtain/ui-curtain.en.js';
import '../ui-datepicker/ui-datepicker.en.js';
import '../ui-daterange/ui-daterange.en.js';
import '../ui-dialogbubble/ui-dialogbubble.en.js';
import '../ui-dropdown/ui-dropdown.en.js';
import '../ui-feedback/ui-feedback.en.js';
import '../ui-field/ui-field.en.js';
import '../ui-footer/ui-footer.en.js';
import '../ui-form/ui-form.en.js';
import '../ui-message/ui-message.en.js';
import '../ui-modal/ui-modal.en.js';
import '../ui-monthpicker/ui-monthpicker.en.js';
import '../ui-nav/ui-nav.en.js';
import '../ui-navitem/ui-navitem.en.js';
import '../ui-navlist/ui-navlist.en.js';
import '../ui-navtoggle/ui-navtoggle.en.js';
import '../ui-offer/ui-offer.en.js';
import '../ui-pagination/ui-pagination.en.js';
import '../ui-phonefield/ui-phonefield.en.js';
import '../ui-searchinput/ui-searchinput.en.js';
import '../ui-signing/ui-signing.en.js';
import '../ui-skip-to-content/ui-skip-to-content.en.js';
import '../ui-slider/ui-slider.en.js';
import '../ui-slides/ui-slides.en.js';
import '../ui-stepper/ui-stepper.en.js';
import '../ui-table-cloneable/ui-table-cloneable.en.js';
import '../ui-table-expandable/ui-table-expandable.en.js';
import '../ui-table-sortable/ui-table-sortable.en.js';
import '../ui-tabs/ui-tabs.en.js';
import '../ui-textcounter/ui-textcounter.en.js';
import '../ui-timerange/ui-timerange.en.js';
import '../ui-tooltip/ui-tooltip.en.js';
import '../ui-upload-item/ui-upload-item.en.js';
import '../ui-upload/ui-upload.en.js';
import '../ui-video/ui-video.en.js';
import '../ui-wizard/ui-wizard.en.js';
import { Labels } from '../../shared-components/global/labels.js';

Labels.LANGUAGE = 'en';

window.UI = { ...window.UI, Labels };
